export default class ApiError extends Error {

  public status: number;

  constructor(status: number, message: string) {
    super();
    this.name = this.constructor.name;
    this.message = message;
    this.status = status;
  }
}
